export default {
      id: "project-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#project",
      toString: function () {
        return this.url;
      }
    }